import { DialogProps } from "@mui/material";
import { createContext, ReactNode, useState } from "react";

type Modal = {
    content: ReactNode;
    title: string;
    sx?: DialogProps;
    disableBackdropClick?: boolean;
};

export const CustomModalContext = createContext<any>({
    isCustomModalActive: false,
    updateIsCustomModalActive: (value: boolean) => {},
    updateModal: (value: Modal) => {},
    modal: {
        content: null as ReactNode,
        title: "",
        sx: { open: false } as DialogProps,
        disableBackdropClick: false,
    },
});

export const CustomModalContextProvider = (props: any) => {
    const [isCustomModalActive, setIsCustomModalActive] =
        useState<boolean>(false);
    const [modal, setModal] = useState<Modal>({
        content: null as ReactNode,
        title: "",
        sx: { open: false },
    });

    const updateIsCustomModalActive = (value: boolean) =>
        setIsCustomModalActive(value);

    const updateModal = (value: Modal) => setModal(value);

    return (
        <CustomModalContext.Provider
            value={{
                isCustomModalActive,
                updateIsCustomModalActive,
                updateModal,
                modal,
            }}
        >
            {props.children}
        </CustomModalContext.Provider>
    );
};
